"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ZaynTrustSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 8 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            bgcolor: "#F7F4FD",
            borderRadius: "24px",
            px: { xs: 3, sm: 5, md: 7 },
            py: { xs: 4, sm: 5, md: 6 },
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "40% 60%" },
              gap: { xs: 3, md: 5, lg: 6 },
            }}
          >
            {/* Left - Label + Heading */}
            <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "11px", sm: "12px" },
                  fontWeight: 500,
                  color: "#7A2BF5",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  fontFamily: "var(--font-outfit)",
                  mb: { xs: 1.5, sm: 2 },
                }}
              >
                {t("zaynTrust.label")}
              </Typography>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "22px", sm: "26px", md: "28px" },
                  fontWeight: 700,
                  lineHeight: 1.3,
                  color: "#14122B",
                  fontFamily: "var(--font-plusjakarta)",
                }}
              >
                {t("zaynTrust.heading")}
              </Typography>
            </Box>

            {/* Right - Description */}
            <Box>
              <Typography
                sx={{
                  fontSize: { xs: "13px", sm: "14px", md: "15px" },
                  color: "#55556E",
                  lineHeight: 1.8,
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("zaynTrust.description")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynTrustSection;